import React, { useState } from "react";
import {
  FaUser,
  FaEnvelope,
  FaLock,
  FaPhone,
  FaBuilding,
} from "react-icons/fa";
import { useDispatch } from "react-redux";
import { SellerRegisterApi } from "../../redux/slices/SellerRegisterSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const SellerRegister = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    phone: "",
    businessName: "",
    gstNumber: "",
    shopName: "",
    businessAddress: "",
    bankDetails: {
      accountNumber: "",
      ifscCode: "",
      bankName: "",
      holderName: "",
    },
  });

  const passwordRules = {
    length: formData.password.length >= 8,
    upper: /[A-Z]/.test(formData.password),
    lower: /[a-z]/.test(formData.password),
    number: /[0-9]/.test(formData.password),
    special: /[^A-Za-z0-9]/.test(formData.password),
  };

  const isPasswordValid = Object.values(passwordRules).every(Boolean);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const handleBankChange = (e) => {
  setFormData({
    ...formData,
    bankDetails: {
      ...formData.bankDetails,
      [e.target.name]: e.target.value,
    },
  });
};
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isPasswordValid) {
      toast.error("Password does not meet requirements", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    setLoading(true);
    try {
      dispatch(SellerRegisterApi(formData)).then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          toast.success("Registration Successful Thank You! We review your request and get back to you soon.", {
            position: "top-right",
            autoClose: 2000,
          });

          navigate("/SellerLogin");
        } else {
          toast.error("Registration Failed!", {
            position: "top-right",
            autoClose: 2000,
          });
        }
      });
    } catch (error) {
      toast.error("Registration Failed!", {
        position: "top-right",
        autoClose: 2000,
      });
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100 px-4">
      <div className="w-full max-w-4xl bg-white/80 backdrop-blur-lg rounded-2xl shadow-2xl p-6 sm:p-10">

        <h2 className="text-3xl font-bold text-center text-gray-700 mb-8 ">
          Registration Form
        </h2>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6 ">
          <div className="relative">
            <FaUser className="absolute left-3 top-5 text-indigo-500" />
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none focus:border-indigo-500"
            />
            <label className="floating-label">Full Name</label>
          </div>

          <div className="relative">
            <FaEnvelope className="absolute left-3 top-5 text-blue-500" />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none focus:border-blue-500"
            />
            <label className="floating-label">Email Address</label>
          </div>

          <div className="relative">
            <FaLock className="absolute left-3 top-5 text-pink-500" />

            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-10 py-3 focus:outline-none focus:border-pink-500"
            />

            <label className="floating-label">Password</label>
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-5 cursor-pointer text-gray-600 hover:text-gray-800"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="relative">
            <FaPhone className="absolute left-3 top-5 text-green-500" />
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none focus:border-green-500"
            />
            <label className="floating-label">Mobile Number</label>
          </div>

          <div className="relative">
            <FaBuilding className="absolute left-3 top-5 text-orange-500" />
            <input
              type="text"
              name="businessName"
              value={formData.businessName}
              onChange={handleChange}
              required
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none focus:border-orange-500"
            />
            <label className="floating-label">Business Name</label>
          </div>

          <div className="relative">
            <FaBuilding className="absolute left-3 top-5 text-purple-500" />
            <input
              type="text"
              name="shopName"
              value={formData.shopName}
              onChange={handleChange}
              required
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none focus:border-purple-500"
            />
            <label className="floating-label">Shop Name</label>
          </div>

          <div className="relative">
            <FaBuilding className="absolute left-3 top-5 text-purple-500" />
            <input
              type="text"
              name="businessAddress"
              value={formData.businessAddress}
              onChange={handleChange}
              required
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none focus:border-purple-500"
            />
            <label className="floating-label">Business Address</label>
          </div>

          <div className="relative md:col-span-2">
            <FaBuilding className="absolute left-3 top-5 text-red-500" />
            <input
              type="text"
              name="gstNumber"
              value={formData.gstNumber}
              onChange={handleChange}
              required
              maxLength={15}
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none focus:border-red-500"
            />
            <label className="floating-label">
              GST Number (15 Digits)
            </label>
          </div>
      <div className="md:col-span-2 mt-4">
            <h3 className="text-xl font-semibold text-gray-700 mb-4">
              Bank Details (Optional)
            </h3>
          </div>

          <div className="relative">
            <FaBuilding className="absolute left-3 top-5 text-indigo-500" />
            <input
              type="text"
              name="holderName"
              value={formData.bankDetails.holderName}
              onChange={handleBankChange}
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none"
            />
            <label className="floating-label">Account Holder Name</label>
          </div>

          <div className="relative">
            <FaBuilding className="absolute left-3 top-5 text-green-500" />
            <input
              type="text"
              name="bankName"
              value={formData.bankDetails.bankName}
              onChange={handleBankChange}
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none"
            />
            <label className="floating-label">Bank Name</label>
          </div>

          <div className="relative">
            <FaBuilding className="absolute left-3 top-5 text-blue-500" />
            <input
              type="text"
              name="accountNumber"
              value={formData.bankDetails.accountNumber}
              onChange={handleBankChange}
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none"
            />
            <label className="floating-label">Account Number</label>
          </div>

          <div className="relative">
            <FaBuilding className="absolute left-3 top-5 text-red-500" />
            <input
              type="text"
              name="ifscCode"
              value={formData.bankDetails.ifscCode}
              onChange={handleBankChange}
              placeholder=" "
              className="peer w-full border border-gray-300 rounded-lg pl-10 pr-3 py-3 focus:outline-none"
            />
            <label className="floating-label">IFSC Code</label>
          </div>
          <div className="md:col-span-2">
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3 rounded-lg font-semibold tracking-wide hover:scale-[1.02] transition-transform"
            >
              {loading ? "Registering..." : "Register Seller"}
            </button>
          </div>
        </form>

        <p className="text-center mt-6 text-gray-600">
          Already registered?{" "}
          <button
            type="button"
            onClick={() => navigate('/SellerLogin')}
            className="text-sm text-indigo-600 hover:underline"
          >
            Login
          </button>
        </p>
      </div>

      {/* Floating Label Styles */}
      <style>{`
      .floating-label {
        position: absolute;
        left: 40px;
        top: 50%;
        transform: translateY(-40%);
        color: #6b7280;
        font-size: 14px;
        pointer-events: none;
        transition: 0.2s;
        background: white;
        padding: 0 4px;
      }

      input:focus + .floating-label,
      input:not(:placeholder-shown) + .floating-label {
        top: -6px;
        font-size: 12px;
        color: #4f46e5;
      }
    `}</style>
    </div>
  );

};

export default SellerRegister;
